import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo">
      <a href="/" className="logo-link">
        <img 
          src="/images/GenixLogo.png" 
          alt="Genix AI" 
          className="logo-image"
        />
      </a>
    </div>
  );
};

export default Logo; 